import React from "react"

const ApplicantsContext = React.createContext({})

const { Provider, Consumer } = ApplicantsContext

export { Provider, Consumer, ApplicantsContext }
